export const getToken = () => localStorage.getItem('admin_token');
export const getUser = () => {
  const u = localStorage.getItem('admin_user');
  return u ? JSON.parse(u) : null;
};
export const setAuth = (token: string, user: any) => {
  localStorage.setItem('admin_token', token);
  localStorage.setItem('admin_user', JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_user');
};
export const isAuthenticated = () => !!getToken();
